import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
import { FAQS } from './salesData';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section id="faq" className="bg-cream py-11 sm:py-14" data-id="element-51" data-mp="1bmd8ncjfgm7p">
      <div className="mx-auto max-w-md px-5 sm:max-w-2xl" data-id="element-52" data-mp="1gitwe5mpsyk9">
        <h2 className="text-center font-display text-[1.4rem] font-extrabold tracking-tight text-charcoal sm:text-[2rem]" data-id="element-53" data-mp="1glgcwurl2oem">
          Preguntas frecuentes
        </h2>

        <div className="mt-5 space-y-2" data-id="element-54" data-mp="28a9ryp691vmm">
          {FAQS.map((faq, i) => {
          const isOpen = open === i;
          return <div key={i} className="overflow-hidden rounded-2xl border border-stone bg-white shadow-[0_10px_30px_-26px_rgba(56,37,34,0.5)]" data-id="element-55" data-mp="1zihlsqo9d8nu" data-mpi={i}>
                <button onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-3.5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" data-id="element-56" data-mp="2n67h3nhr9zpc">
                  <span className="font-display text-[0.9rem] font-semibold leading-snug text-charcoal sm:text-[0.98rem]" data-id="element-57" data-mp="1el3m8vh1v651">
                    {faq.q}
                  </span>
                  <PlusIcon className={`h-5 w-5 shrink-0 text-gold transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden strokeWidth={3} data-id="element-58" data-mp="19sagc49uhrrd" />
                </button>
                <AnimatePresence initial={false} data-id="element-59" data-mp="1xhli9p2xls73">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-60" data-mp="1sis4dvjqfz6e">
                      <div className="px-5 pb-4" data-id="element-61" data-mp="239929cxedkix">
                        <p className="font-sans text-[0.86rem] leading-relaxed text-taupe" data-id="element-62" data-mp="23a0wokf9dc7m">
                          {faq.a}
                        </p>
                        {faq.a2 && <p className="mt-2 font-sans text-[0.86rem] leading-relaxed text-taupe" data-id="element-63" data-mp="2c6jf32pv5hpy">
                            {faq.a2}
                          </p>}
                        {faq.link && <a href={faq.link.href} target="_blank" rel="noreferrer" className="mt-2 inline-block font-sans text-[0.78rem] font-semibold text-gold-deep underline decoration-gold/40 underline-offset-2 transition-colors duration-200 ease-out hover:text-charcoal focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-gold" data-id="element-64" data-mp="2qx8u6g6g3gz3">
                            {faq.link.label}
                          </a>}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}